import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 8,
	height: 14,
	viewBox: "0 0 8 14",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		transform: "rotate(90 10.5 5.5)",
		children: [/* @__PURE__ */ _jsx("polygon", { points: "0 24 24 24 24 0 0 0" }), /* @__PURE__ */ _jsx("polygon", {
			fill: "currentColor",
			fillRule: "nonzero",
			points: "12 13.172 7.05 8.222 5.636 9.636 12 16 18.364 9.636 16.95 8.222"
		})]
	})
});
export default SvgArrowLeft;
